export class Upload {
    $key: string;
    file:File;
    b64:any;
    name:string;
    type:string;
    document_type:string;
    specific_root:string;
    url:string;
    progress:any;
    createdAt: Date = new Date();

    constructor(file:any) {
        this.file = file;
    }
}


// WEBPACK FOOTER //
// ./src/services/upload.ts